import React from 'react'
import PropTypes from 'prop-types'

// "Nothing here yet" inside a panel, grid or result list; callers own the wording.

const EmptyState = ({ title, subtitle }) => (
  <div className="gl-empty">
    <div className="gl-empty-title">{title}</div>
    {subtitle && <div className="gl-empty-sub">{subtitle}</div>}
  </div>
)

EmptyState.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
}

export default EmptyState
